import React from "react";
import styles from "./SSO.module.scss";

const Loading = ({ id = "ssoLottie" }) => {
    return (
        <div className={styles.loadingSection}>
            <div className={styles.loadingBox}>
                <div className={styles.lottie}>
                    <div className={styles.lottieContainer} id={id} />
                </div>
            </div>
        </div>
    );
};

export default Loading;